import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLangManagement } from './useLangManagement';
import { ITeamFormVal } from '../components/ParticipantsTable/AddTeamForm/AddTeamForm';
import { IFlagList, ISingleFlag } from '../constans/flags';

export const useAddTeam = () => {
  const { i18n } = useTranslation();
  const { flagsList, flagListAlternativeNames } = useLangManagement();
  const availableLanguages = i18n.languages;
  const { language } = i18n;

  const langArrWithIcons = useMemo(() => {
    return availableLanguages.map((lang: string) => flagsList[lang as keyof IFlagList]);
  }, [availableLanguages, flagsList]);

  const alternativeLangArrWithIcons = useMemo(() => {
    return availableLanguages.map((lang: string) => flagListAlternativeNames[lang as keyof IFlagList]);
  }, [availableLanguages, flagListAlternativeNames]);

  const getCurrentLanguageObject = useCallback(
    (baseLang: string) => flagsList[baseLang as keyof IFlagList],
    [language, flagsList]
  );

  const getLangObjectShort = useCallback(
    (lang: string) => {
      const currentObj = getCurrentLanguageObject(lang);
      const { name, ...langObj } = currentObj;
      return { ...langObj, name: langObj?.flagName };
    },
    [language]
  );

  const transformForSubmit = ({ name, preferredLanguage }: ITeamFormVal) => ({
    name,
    preferredLanguage: preferredLanguage.shortName,
  });

  const getCurrentAlternativeLangObj = useCallback(
    (baseLang: string | null) => {
      return alternativeLangArrWithIcons.find(
        ({ shortName }: ISingleFlag) => shortName === baseLang
      );
    },
    [alternativeLangArrWithIcons]
  );
  return {
    langArrWithIcons,
    alternativeLangArrWithIcons,
    getCurrentLanguageObject,
    transformForSubmit,
    getLangObjectShort,
    getCurrentAlternativeLangObj,
  };
};
